import React, { useState } from "react";
import { Button } from "../../ui-library/Button/Button.tsx";
import { Input } from "../../ui-library/Input/Input.tsx";
import styles from "./Login.module.css";

export const PasswordlessForm: React.FC<{
  onSubmit: (email: string) => void;
  disabled: boolean;
  failedEmail?: string | null;
}> = (props) => {
  const [email, setEmail] = useState("");
  return (
    <div className={styles.PasswordlessContainer}>
      <div className={styles.PasswordlessHeader}>
        <h1 className={styles.PasswordlessTitle}>Sign in with email link</h1>
        <p className={styles.PasswordlessSubtitle}>
          Enter your email address to receive a sign-in link.
        </p>
      </div>
      <form
        className={styles.PasswordlessForm}
        onSubmit={(e) => {
          e.preventDefault();
          props.onSubmit(email.trim());
        }}
      >
        <Input
          className={styles.PasswordlessInput}
          placeholder="Enter your email"
          inputMode="email"
          autoComplete="email"
          id={"email"}
          name={"email"}
          type={"email"}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button
          className={styles.PasswordlessButton}
          type="submit"
          disabled={props.disabled || !email.trim()}
        >
          Send sign-in link
        </Button>
        {props.failedEmail && (
          <p className={styles.ErrorMessage}>
            Failed to send link to {props.failedEmail}. Please try again.
          </p>
        )}
      </form>
    </div>
  );
};
